__turbopack_context__.v({
  "item": "_4o3xaW_item",
  "itemIndicator": "_4o3xaW_itemIndicator",
});
